import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contex/AuthContext.jsx";
import { Reviews_Route } from "../../router/routes.js";

function Login() {
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const { login, user, isLoading } = useAuth();
    const navigate = useNavigate();

    const logIn = async (e) => {
        e.preventDefault();
        try {
            await login(userName, password);
            navigate(Reviews_Route);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (user) {
            navigate(Reviews_Route);
        }
    }, [user, isLoading, navigate]);


    return (
        <div className="login-container">
            {isLoading ? (
                <p className="loading-text">Loading...</p>
            ) : (
                <div className="login-section">
                    <div className="login-header">
                        <h2>Sign In</h2>
                    </div>
                    <div className="login-form">
                        <form onSubmit={logIn}>
                            <label>Username</label>
                            <input
                                type="text"
                                required
                                value={userName}
                                onChange={(e) => setUserName(e.target.value)}
                            />
                            <label>Password</label>
                            <input
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <button type="submit">Log In</button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Login;
